import { checkIsGoBackSIA, useCheckPrepaidSIMLimitation } from '@vfit/consumer/data-access';
import { useEffect, useRef } from 'react';
import { useCheckout } from '../../../iBuyMobile.context';

export const useCheckPrepaidSimLimit = () => {
  const { isLoadingCart, findCaller, customerId, campaign, setCustomerFlow, customerFlow } =
    useCheckout();

  const { mutate, isError, isSuccess, isLoading, error, data } = useCheckPrepaidSIMLimitation();

  const hasCalledRef = useRef(false);

  const customerRefId = findCaller?.customerRef?.id;
  const isAccepted = campaign?.accept?.isAccepted;

  /**
   * chiama API UNA volta sola???
   */
  useEffect(() => {
    if (
      hasCalledRef.current ||
      isLoadingCart ||
      checkIsGoBackSIA() ||
      !(customerRefId || customerId)
    ) {
      return;
    }

    hasCalledRef.current = true;
    mutate();
  }, [isLoadingCart, customerRefId, customerId, isAccepted, mutate]);

  useEffect(() => {
    if (isLoading) return;

    if (isError && !isSuccess) {
      setCustomerFlow({
        ...customerFlow,
        checkPrepaidSim: {
          isError: true,
          isSuccess: false,
          isLoading: false,
          error: { errorCode: 'checkPrepaidSim_geneicError', error },
        },
      });
    }

    if (
      isSuccess &&
      !isError &&
      (data?.validationStatus?.toUpperCase() === 'FAILURE' || data?.errorDetails?.errorCode)
    ) {
      setCustomerFlow({
        ...customerFlow,
        checkPrepaidSim: {
          isError: true,
          isSuccess: false,
          isLoading: false,
          error: { errorCode: 'checkPrepaidSim_limitReached', error },
        },
      });
    }
  }, [isError, isSuccess, isLoading]);

  return null;
};

